export default "__VITE_ASSET__DOCG5WmF__"